import { Outlet, useLocation, useParams, useSearchParams } from 'react-router';
import { memo, useEffect, useMemo } from 'react';
import { setLeadId, useAnalytics } from '../../redux/ducks/analytics';
import { isBooleanTrue, isObjectNotEmpty, isStringNotEmpty } from '../../utils/objectUtils';
import { toLower } from 'lodash';
import { useDeepCompareEffect, useDeepCompareEffectNoCheck } from '../../hooks/useDeepCompareEffect';
import { update } from '@intercom/messenger-js-sdk';
import { shouldHideIntercomLauncher } from '../../utils/intercomUtils';
import { useDispatch } from 'react-redux';
import LoadingWrapper from '../../components/LoadingWrapper';
import { useAuth } from '../../redux/ducks/auth';
import TrackingService from '../../services/TrackingService';

const WrapperLayout = (props) => {
	//#region useDispatch

	const dispatch = useDispatch();

	//#endregion
	//#region useLocation

	const location = useLocation();

	//#endregion
	//#region useAnalytics

	const { isAuthLoading } = useAuth();

	//#endregion
	//#region useAnalytics

	const { updateAnalyticsAndAffiliateInfo, theOfferSession, lead } = useAnalytics();

	//#endregion
	//#region useSearchParams

	const [searchParams, setSearchParams] = useSearchParams();
	const queryObj = Object.fromEntries(searchParams.entries());

	const affiliateId = searchParams.get('a') ? toLower(searchParams.get('a')) : (searchParams.get('fpr') ? toLower(searchParams.get('fpr')) : 'none');
	// const subAffiliateId = searchParams.get('sa') ? toLower(searchParams.get('sa')) : 'none';
	// const campaignSlug = searchParams.get('c') ? toLower(searchParams.get('c')) : null;
	// const creativeId = searchParams.get('cr') ? toLower(searchParams.get('cr')) : null;
	const version = searchParams.get('v') ? toLower(searchParams.get('v')) : null;
	// const clickId = searchParams.get('cid') ? searchParams.get('cid') : (searchParams.get('irclickid') ? searchParams.get('irclickid') : (searchParams.get('fbclid') ? searchParams.get('fbclid') : (searchParams.get('ttclid') ? searchParams.get('ttclid') : (searchParams.get('gclid') ? searchParams.get('gclid') : null))));
	const source = searchParams.get('s');
	const couponCode = searchParams.get('coupon') ? (['alwaysready'].includes(toLower(searchParams.get('coupon'))) ? 'alwaysready26' : toLower(searchParams.get('coupon'))) : TrackingService.DEFAULT_COUPON_CODE;
	const testMode = searchParams.get('test') ? isBooleanTrue(searchParams.get('test')) : false;
	const fbclid = searchParams.get('fbclid') ? searchParams.get('fbclid') : null;
	// const ttclid = searchParams.get('ttclid') ? searchParams.get('ttclid') : null;
	// const gclid = searchParams.get('gclid') ? searchParams.get('gclid') : null;
	// const irclickid = searchParams.get('irclickid') ? searchParams.get('irclickid') : null;
	const addon = searchParams.get('addon') ? isBooleanTrue(searchParams.get('addon')) : false;
	const leadId = searchParams.get('lid') ? searchParams.get('lid') : null;
	// const sessionId = searchParams.get('sid') ? searchParams.get('sid') : null;

	// https://app.readyrx.com/?a=1&sub1={affiliate_id}&sub2={sub1}&sub3={sub2}&sub4={offer_id}&sub5={transaction_id}&domain1={tracking_domain}&c={affiliate_id}&cr={creative_id}&v={version}
	// Everflow Query Parameter Setup
	// const offerId = searchParams.get('oid') ? searchParams.get('oid') : null;
	// const affId = searchParams.get('affid') ? searchParams.get('affid') : null;
	// const sub1 = searchParams.get('sub1') ? searchParams.get('sub1') : null;
	// const sub2 = searchParams.get('sub2') ? searchParams.get('sub2') : null;
	// const sub3 = searchParams.get('sub3') ? searchParams.get('sub3') : null;
	// const sub4 = searchParams.get('sub4') ? searchParams.get('sub4') : null;
	// const sub5 = searchParams.get('sub5') ? searchParams.get('sub5') : null;
	// const uId = searchParams.get('uid') ? searchParams.get('uid') : null;
	// const sourceId = searchParams.get('source_id') ? searchParams.get('source_id') : null;
	// const transactionId = searchParams.get('sid') ? searchParams.get('sid') : (searchParams.get('cid') ? searchParams.get('cid') : null);

	


	const queryParameters = useMemo(() => {
		return {
			affiliateId: queryObj['a'] ? toLower(queryObj['a']) : (queryObj['fpr'] ? queryObj['fpr'] : 'none'),
			subAffiliateId: queryObj['sa'] ? toLower(queryObj['sa']) : 'none',
			campaignSlug: queryObj['c'] ? toLower(queryObj['c']) : null,
			creativeId: queryObj['cr'] ? toLower(queryObj['cr']) : null,
			//source: queryObj['s'],
			//version: queryObj['v'] ? toLower(queryObj['v']) : null,
			couponCode: queryObj['coupon'] ? (['alwaysready'].includes(toLower(queryObj['coupon'])) ? 'alwaysready26' : toLower(queryObj['coupon'])) : TrackingService.DEFAULT_COUPON_CODE,
			//testMode: queryObj['test'] ? isBooleanTrue(queryObj['test']) : false,
			//addon: queryObj['addon'] ? isBooleanTrue(queryObj['addon']) : false,
			//leadId: queryObj['lid'] ? queryObj['lid'] : null,
			clickId: queryObj['cid'] ? queryObj['cid'] : (queryObj['irclickid'] ? queryObj['irclickid'] : (queryObj['fbclid'] ? queryObj['fbclid'] : (queryObj['ttclid'] ? queryObj['ttclid'] : (queryObj['gclid'] ? queryObj['gclid'] : (queryObj['rdt_cid'] ? queryObj['rdt_cid'] : ((queryObj['ScCid'] || queryObj['SsCid']) ? (queryObj['ScCid'] || queryObj['SsCid']) : (queryObj['msclkid'] ? queryObj['msclkid'] : (queryObj['twclid'] ? queryObj['twclid'] : (queryObj['nbclid'] ? queryObj['nbclid'] : (queryObj['gbraid'] ? queryObj['gbraid'] : null)))))))))),

			fbclid: queryObj['fbclid'] ? queryObj['fbclid'] : null,
			ttclid: queryObj['ttclid'] ? queryObj['ttclid'] : null,
			gclid: queryObj['gclid'] ? queryObj['gclid'] : null,
			irclickid: queryObj['irclickid'] ? queryObj['irclickid'] : null,
			rdt_cid: queryObj['rdt_cid'] ? queryObj['rdt_cid'] : null,
			SsCid: queryObj['ScCid'] || queryObj['SsCid'] || null,
			msclkid: queryObj['msclkid'] ? queryObj['msclkid'] : null,
			twclid: queryObj['twclid'] ? queryObj['twclid'] : null,
			nbclid: queryObj['newsbreak_cid'] || queryObj['nbclid'] || null,
			gbraid: queryObj['gbraid'] ? queryObj['gbraid'] : null,
			sessionId: queryObj['sid'] ? queryObj['sid'] : null,
			theOfferSession: queryObj['sid'] ? queryObj['sid'] : null,

			offerId: queryObj['oid'] ? queryObj['oid'] : null,
			affId: queryObj['affid'] ? queryObj['affid'] : null,
			sub1: queryObj['sub1'] ? queryObj['sub1'] : null,
			sub2: queryObj['sub2'] ? queryObj['sub2'] : null,
			sub3: queryObj['sub3'] ? queryObj['sub3'] : null,
			sub4: queryObj['sub4'] ? queryObj['sub4'] : null,
			sub5: queryObj['sub5'] ? queryObj['sub5'] : null,
			uId: queryObj['uid'] ? queryObj['uid'] : null,
			sourceId: queryObj['source_id'] ? queryObj['source_id'] : null,
			transactionId: queryObj['_ef_transaction_id'] || queryObj['sid'] || queryObj['cid'] || null,

			utm_source: queryObj['utm_source'] ? queryObj['utm_source'] : null,
			utm_medium: queryObj['utm_medium'] ? queryObj['utm_medium'] : null,
			utm_campaign: queryObj['utm_campaign'] ? queryObj['utm_campaign'] : null,
			utm_term: queryObj['utm_term'] ? queryObj['utm_term'] : null,
			utm_content: queryObj['utm_content'] ? queryObj['utm_content'] : null
		};
	}, [queryObj]);

	//#endregion
	//#region useParams

	const params = useParams();

	//#endregion

	// useDeepCompareEffect(() => {
	// 	console.log('queryParameters', queryParameters);
	// 	updateAnalyticsAndAffiliateInfo({ ...queryParameters });
	// }, [queryParameters]);

	useEffect(() => {
		updateAnalyticsAndAffiliateInfo({ source: source });
	}, [source]);

	useEffect(() => {
		// console.log('queryObj?.v updated', queryObj?.v);
		updateAnalyticsAndAffiliateInfo({ version: version });
	}, [version]);

	// useEffect(() => {
	// 	// console.log('queryObj?.coupon updated', queryObj?.coupon);
	// 	updateAnalyticsAndAffiliateInfo({ couponCode: couponCode });
	// }, [couponCode]);

	useEffect(() => {
		// console.log('queryObj?.test updated', queryObj?.test);
		updateAnalyticsAndAffiliateInfo({ testMode: testMode });
	}, [testMode]);

	useEffect(() => {
		// console.log('queryObj?.addon updated', queryObj?.addon);
		updateAnalyticsAndAffiliateInfo({ addon: addon });
	}, [addon]);

	useEffect(() => {
		// console.log('queryObj?.lid updated', queryObj?.lid);
		dispatch(setLeadId(leadId));
	}, [leadId]);

	useEffect(() => {
		// console.log('fbclid updated', queryObj?.fbclid);
		if (isStringNotEmpty(fbclid)) {
			let newSiteVisitAt = Math.floor(Date.now() / 1000);
			let newFbc = `fb.1.${newSiteVisitAt}.${fbclid}`;
			// console.log('fbc', newFbc);

			updateAnalyticsAndAffiliateInfo({
				fbclid: fbclid,
				siteVisitAt: newSiteVisitAt,
				fbc: newFbc
			});
		} else {
			updateAnalyticsAndAffiliateInfo({
				fbclid: null,
				siteVisitAt: null,
				fbc: null
			});
		}
	}, [fbclid]);

	useEffect(() => {
		// console.log('params updated', params);
		let programSlug = params?.programSlug ?? null;
		let offerToken = params?.productSku ?? null;
		let productCategorySlug = params?.productCategorySlug ?? null;

		updateAnalyticsAndAffiliateInfo({ offerToken: offerToken, programSlug: programSlug, productCategorySlug: productCategorySlug });
	}, [params?.programSlug, params?.productSku, params?.productCategorySlug]);

	useDeepCompareEffect(() => {
		// console.log('old current Params', searchParams.toString());
		// console.log('theOfferSession', theOfferSession);
		if (affiliateId === '2') {
			if (isStringNotEmpty(theOfferSession)) {
				setSearchParams(params => {
					// console.log('current Params', params);
					if (!params.has('sid')) {
						params.set('sid', theOfferSession);
					}
					return params;
				}, { replace: true });
			}
		}
	}, [setSearchParams, theOfferSession, affiliateId]);

	useDeepCompareEffectNoCheck(() => {
		// console.log('lead update searchParams', lead, lead?.affiliateInfo);
		if (isObjectNotEmpty(lead) && isStringNotEmpty(lead?.affiliateId) && lead?.affiliateId !== 'none') {
			setSearchParams(params => {
				if ((!params.has('a') || params.get('a') === 'none') && isStringNotEmpty(lead?.affiliateId) && lead?.affiliateId !== 'none') {
					params.set('a', lead?.affiliateId);

					if ((!params.has('sa') || params.get('sa') === 'none') && isStringNotEmpty(lead?.subAffiliateId) && lead?.subAffiliateId !== 'none') {
						params.set('sa', lead?.subAffiliateId);
					}

					if (isObjectNotEmpty(lead?.affiliateInfo) && isStringNotEmpty(lead?.affiliateInfo?.affiliateId) && lead?.affiliateInfo?.affiliateId !== 'none') {
						if (!params.has('cr') && isStringNotEmpty(lead?.affiliateInfo?.creativeId)) {
							params.set('cr', lead?.affiliateInfo?.creativeId);
						}
						// let customer see whatever version of the funnel is the latest
						// if (!params.has('v') && isStringNotEmpty(lead?.affiliateInfo?.version)) {
						// 	params.set('v', lead?.affiliateInfo?.version);
						// }
						// if (!params.has('s') && isStringNotEmpty(lead?.affiliateInfo?.source)) {
						// 	params.set('s', lead?.affiliateInfo?.source);
						// }
						if (!params.has('cid') && isStringNotEmpty(lead?.affiliateInfo?.clickId)) {
							params.set('cid', lead?.affiliateInfo?.clickId);
						}
						if (!params.has('sid') && (isStringNotEmpty(lead?.affiliateInfo?.sessionId) || isStringNotEmpty(lead?.affiliateInfo?.theOfferSession))) {
							if (isStringNotEmpty(lead?.affiliateInfo?.sessionId)) {
								params.set('sid', lead?.affiliateInfo?.sessionId);
							} else if (isStringNotEmpty(lead?.affiliateInfo?.theOfferSession)) {
								params.set('sid', lead?.affiliateInfo?.theOfferSession);
							}
						}

						if (!params.has('oid') && isStringNotEmpty(lead?.affiliateInfo?.offerId)) {
							params.set('oid', lead?.affiliateInfo?.offerId);
						}
						if (!params.has('affid') && isStringNotEmpty(lead?.affiliateInfo?.affId)) {
							params.set('affid', lead?.affiliateInfo?.affId);
						}
						if (!params.has('sub1') && isStringNotEmpty(lead?.affiliateInfo?.sub1)) {
							params.set('sub1', lead?.affiliateInfo?.sub1);
						}
						if (!params.has('sub2') && isStringNotEmpty(lead?.affiliateInfo?.sub2)) {
							params.set('sub2', lead?.affiliateInfo?.sub2);
						}
						if (!params.has('sub3') && isStringNotEmpty(lead?.affiliateInfo?.sub3)) {
							params.set('sub3', lead?.affiliateInfo?.sub3);
						}
						if (!params.has('sub4') && isStringNotEmpty(lead?.affiliateInfo?.sub4)) {
							params.set('sub4', lead?.affiliateInfo?.sub4);
						}
						if (!params.has('sub5') && isStringNotEmpty(lead?.affiliateInfo?.sub5)) {
							params.set('sub5', lead?.affiliateInfo?.sub5);
						}
						if (!params.has('uid') && isStringNotEmpty(lead?.affiliateInfo?.uId)) {
							params.set('uid', lead?.affiliateInfo?.uId);
						}
						if (!params.has('source_id') && isStringNotEmpty(lead?.affiliateInfo?.sourceId)) {
							params.set('source_id', lead?.affiliateInfo?.sourceId);
						}
						if (!params.has('_ef_transaction_id') && isStringNotEmpty(lead?.affiliateInfo?.transactionId)) {
							params.set('_ef_transaction_id', lead?.affiliateInfo?.transactionId);
						}
						if (!params.has('transaction_id') && isStringNotEmpty(lead?.affiliateInfo?.transactionId)) {
							params.set('transaction_id', lead?.affiliateInfo?.transactionId);
						}

						if ((isStringNotEmpty(lead?.referralAffiliateId) || isStringNotEmpty(lead?.referralSubAffiliateId) || isStringNotEmpty(lead?.referralUserId)) && isStringNotEmpty(lead?.couponCode)) {
							params.set('coupon', lead?.couponCode);
						} else if ((isStringNotEmpty(lead?.referralAffiliateId) || isStringNotEmpty(lead?.referralSubAffiliateId) || isStringNotEmpty(lead?.referralUserId)) && isStringNotEmpty(lead?.affiliateInfo?.couponCode)) {
							params.set('coupon', lead?.affiliateInfo?.couponCode);
						} else if (!params.has('coupon') && isStringNotEmpty(lead?.couponCode)) {
							params.set('coupon', lead?.couponCode);
						} else if (!params.has('coupon') && isStringNotEmpty(lead?.affiliateInfo?.couponCode)) {
							params.set('coupon', lead?.affiliateInfo?.couponCode);
						}

						if (!params.has('test') && isBooleanTrue(lead?.testMode)) {
							params.set('test', isBooleanTrue(lead?.testMode));
						}
						if (!params.has('fbclid') && isStringNotEmpty(lead?.affiliateInfo?.fbclid)) {
							params.set('fbclid', lead?.affiliateInfo?.fbclid);
						}
						if (!params.has('ttclid') && isStringNotEmpty(lead?.affiliateInfo?.ttclid)) {
							params.set('ttclid', lead?.affiliateInfo?.ttclid);
						}
						if (!params.has('gclid') && isStringNotEmpty(lead?.affiliateInfo?.gclid)) {
							params.set('gclid', lead?.affiliateInfo?.gclid);
						}
						if (!params.has('irclickid') && isStringNotEmpty(lead?.affiliateInfo?.irclickid)) {
							params.set('irclickid', lead?.affiliateInfo?.irclickid);
						}
						if (!params.has('rdt_cid') && isStringNotEmpty(lead?.affiliateInfo?.rdt_cid)) {
							params.set('rdt_cid', lead?.affiliateInfo?.rdt_cid);
						}
						if (!params.has('ScCid') && !params.has('SsCid') && isStringNotEmpty(lead?.affiliateInfo?.SsCid)) {
							params.set('ScCid', lead?.affiliateInfo?.SsCid);
						}
						if (!params.has('msclkid') && isStringNotEmpty(lead?.affiliateInfo?.msclkid)) {
							params.set('msclkid', lead?.affiliateInfo?.msclkid);
						}
						if (!params.has('twclid') && isStringNotEmpty(lead?.affiliateInfo?.twclid)) {
							params.set('twclid', lead?.affiliateInfo?.twclid);
						}
						if ((!params.has('nbclid') && !params.has('newsbreak_cid')) && isStringNotEmpty(lead?.affiliateInfo?.nbclid)) {
							params.set('nbclid', lead?.affiliateInfo?.nbclid);
							params.set('newsbreak_cid', lead?.affiliateInfo?.nbclid);
						}
						if (!params.has('gbraid') && isStringNotEmpty(lead?.affiliateInfo?.gbraid)) {
							params.set('gbraid', lead?.affiliateInfo?.gbraid);
						}

						if (!params.has('utm_source') && isStringNotEmpty(lead?.affiliateInfo?.utm_source)) {
							params.set('utm_source', lead?.affiliateInfo?.utm_source);
						}
						if (!params.has('utm_campaign') && isStringNotEmpty(lead?.affiliateInfo?.utm_campaign)) {
							params.set('utm_campaign', lead?.affiliateInfo?.utm_campaign);
						}
						if (!params.has('utm_content') && isStringNotEmpty(lead?.affiliateInfo?.utm_content)) {
							params.set('utm_content', lead?.affiliateInfo?.utm_content);
						}
						if (!params.has('utm_medium') && isStringNotEmpty(lead?.affiliateInfo?.utm_medium)) {
							params.set('utm_medium', lead?.affiliateInfo?.utm_medium);
						}
						if (!params.has('utm_term') && isStringNotEmpty(lead?.affiliateInfo?.utm_term)) {
							params.set('utm_term', lead?.affiliateInfo?.utm_term);
						}
					}
				}

				return params;
			}, { replace: true });
		}
	}, [setSearchParams, lead]);

	// hide list lives in shouldHideIntercomLauncher so this and the Intercom boot in AppWrapper
	// can never drift; useHideIntercomLauncher restores the same route state when overlays close.
	useEffect(() => {
		update({ hide_default_launcher: shouldHideIntercomLauncher(location.pathname) });
	}, [location.pathname]);

	useEffect(() => {
		// console.log('path changed, tracking page view...', location?.pathname);
		TrackingService.getStoredVisitData().then((visitData) => {
			if (isObjectNotEmpty(visitData)) {
				TrackingService.trackPageView(visitData).then(() => {
					// console.log('Page view tracked successfully');
				}).catch((err) => {
					console.error('Error tracking page view:', err);
				});
			} else {
				return null;
			}
		}).catch((err) => {
			console.error('Error getting visit data:', err);
			return null;
		});
	}, [location?.pathname]);

	// console.log('WrapperLayout', params, queryObj);

	return (
		<>
			<LoadingWrapper isLoading={isAuthLoading} message="Logging you in..." />
			{props.children}
			<Outlet />
		</>
	);
};
export default memo(WrapperLayout);
